import { render, staticRenderFns } from "./LeadTakerAvatarIcon.vue?vue&type=template&id=3943b8ef&scoped=true&"
import script from "./LeadTakerAvatarIcon.vue?vue&type=script&lang=js&"
export * from "./LeadTakerAvatarIcon.vue?vue&type=script&lang=js&"
import style0 from "./LeadTakerAvatarIcon.vue?vue&type=style&index=0&id=3943b8ef&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3943b8ef",
  null
  
)

export default component.exports